export default __webpack_public_path__ + "static/media/PRA_Wrong_Object-v1.c36f281c.wav";